const defaultRender = (value) => (value ? value : "--");

const columns = [
  {
    title: "Client",
    dataIndex: "userDetails",
    render: defaultRender,
  },
  {
    title: "Mobile Number",
    dataIndex: "mobile_no",
    render: defaultRender,
  },
  {
    title: "Created Date",
    dataIndex: "created_at",
    render: defaultRender,
  },
  {
    title: "Deleted Date",
    dataIndex: "deleted_at",
    render: defaultRender,
  },
  {
    title: "Action",
    dataIndex: "action",
    render: defaultRender,
  },
];

export default columns;